module.exports = __webpack_public_path__ + "static/media/vf_mouter_core.60b0dc71.svg";